import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { usePqrNotificationClient } from './hook';
import { PqrNotificationClientProps } from './props';

export const PqrNotificationClient = (props: PqrNotificationClientProps) => {
    const { showTitle = true } = props;
    const { formik } = usePqrNotificationClient(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            {showTitle && (
                <Grid item xs={12}>
                    <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                        Notificación cliente
                    </Typography>
                </Grid>
            )}
            <Grid item xs={12}>
                <FieldText
                    label="E-mail notificación"
                    name="email"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.email}
                    errors={formik.errors.email}
                    value={formik.values.email}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Teléfono notificación"
                    name="phone"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.phone}
                    errors={formik.errors.phone}
                    value={formik.values.phone}
                    onChange={formik.handleChange}
                />
            </Grid>
        </Grid>
    );
};
